import React from "react";
import List from "./List";
function App() {
  return <List />;
}

export default App;
